var buyAndTradeModalEl = document.getElementById('BuyAndTradeModal');
var _displayedCandyRackPopup = false;
if (buyAndTradeModalEl) {
  var _buyAndTradeAppURL = 'https://api.grademobile.co.uk/v1/Shopify/';

    var tradeInProducts = null;
    var selectedProduct = null;
    var selectedVariant = null;

    var purchaseVariants = null;

    var imeiValid = true;
    var imeiNumber = null;

    var stageElements = [
        document.getElementById('BuyAndTradeStage1'),
        document.getElementById('BuyAndTradeStage2'),
        document.getElementById('BuyAndTradeStage3')
    ];

    var BuyAndTradeButton = document.getElementById('BuyAndTradeButton');
    window.initiateProductBuyAndTrade = function() {

        tradeInProducts = null;
        selectedProduct = null;
        selectedVariant = null;

        purchaseVariants = null;

        imeiValid = true;
        imeiNumber = null;
      
        $.post('/cart/clear.js');
        // BuyAndTradeButton.disabled = true;

        // if (!_displayedCandyRackPopup) {
        //     $.post('/cart/clear.js', function() {
        //         document.dispatchEvent(
        //             new CustomEvent('addToCartButtonClicked', {
        //                 detail: { clonedButton: BuyAndTradeButton, hiddenButton: BuyAndTradeButton },
        //             })
        //         );
        //         BuyAndTradeButton.disabled = false;
        //         _displayedCandyRackPopup = true;
        //     });
        //     return;
        // }

        var variantSelectEl = document.getElementById('product-select-' + currentProductData.id);
        
        if (!variantSelectEl) return;
        
        var currentVariantID = variantSelectEl.options[variantSelectEl.selectedIndex].value;
        var currentVariant = null;

        for (var i = 0; i < currentProductData.variants.length; i++) {
            if (currentProductData.variants[i].id == currentVariantID ) {
                currentVariant = currentProductData.variants[i];
                break;
            }
        }

        if (!currentVariant) {
            console.error("Couldn't find selected variant");
            return false;
        }
         
        displayBuyAndTradeModal();

        //If current variant isn't in the cart, add it
        $.get('/cart.js', function(response) {

            var containsVariant = false;

            for (let i = 0; i < response.items.length; i++) {
                if (response.items[i].variant_id != currentVariant.id) continue;
                containsVariant = true;
                break;
            }

            if (containsVariant) {
                purchaseVariants = response.items.map(function(item) { return { id: item.variant_id, quantity: item.quantity, price: item.price } });  
            } else {
                purchaseVariants = response.items.map(function(item) { return { id: item.variant_id, quantity: item.quantity, price: item.price } });
                $.post('/cart/add.js', { items: [ { id: currentVariant.id, quantity: 1 } ] }, function(cart) {
                    $(document).trigger('theme:cart:updated', [cart, true, true]);
                    purchaseVariants.push({ id: currentVariant.id, quantity: 1, price: currentVariant.price });
                    displayBuyAndTradeModal();
                }, 'json');
            }

        }, 'json');

        return false;
    };

    window.initiateCartBuyAndTrade = function() {
        purchaseVariants = currentCartVariants;
        displayBuyAndTradeModal();
    };

    var imeiCheck = function(imei) {
        if (imei.length != 15) {
            return false;
        }
        var sumTable = [
        [0,1,2,3,4,5,6,7,8,9],
        [0,2,4,6,8,1,3,5,7,9]
        ];
        var sum = 0;
        var flip = 0;
        for (var i = imei.length - 1; i >= 0; i--) {
            sum += sumTable[flip++ & 1][imei.charAt(i)];
        }
        return sum % 10 === 0;
    };


    var displayBuyAndTradeModal = function() {

        if (!purchaseVariants) return;

        buyAndTradeModalEl.classList.add('active');

        if (tradeInProducts) {
            buyAndTradeModalEl.classList.remove('loading');
        }

        buyAndTradeModalEl.classList.add('loading');
            
      $.ajax({
                url: "https://api.grademobile.co.uk/BuyTrade/GetTradeProducts",
                type:"POST",
                headers: { 
                  "Accept" : "application/json; charset=utf-8",
                  "Content-Type": "application/json; charset=utf-8",
                  "APIKey":"4rAhrOcqdWIvNLm2kUhjKeOc3priYS7"
                },
                data:JSON.stringify({forceCheck:false}),
                dataType:"json",        	    
                success:function(response){     
      
                  buyAndTradeModalEl.classList.remove('loading');
                    tradeInProducts = response;

                    tradeInProducts.sort(function(a,b) { 
                        var lc_a_title = a.title.toLowerCase();
                        var lc_b_title = b.title.toLowerCase();

                        if (lc_a_title.includes('iphone') && !lc_b_title.includes('iphone')) return -1;
                        if (lc_b_title.includes('iphone') && !lc_a_title.includes('iphone')) return 1;

                        if (lc_a_title.includes('watch') && !lc_b_title.includes('watch')) return -1;
                        if (lc_b_title.includes('watch') && !lc_a_title.includes('watch')) return 1;

                        if (lc_a_title.includes('ipad') && !lc_b_title.includes('ipad')) return -1;
                        if (lc_b_title.includes('ipad') && !lc_a_title.includes('ipad')) return 1;

                        if (lc_a_title.includes('samsung') && !lc_b_title.includes('samsung')) return -1;
                        if (lc_b_title.includes('samsung') && !lc_a_title.includes('samsung')) return 1;

                        if (lc_a_title.includes('huawei') && !lc_b_title.includes('huawei')) return -1;
                        if (lc_b_title.includes('huawei') && !lc_a_title.includes('huawei')) return 1;

                        return 0;
              });        

                    var html = "";

                    for (var i = 0; i < tradeInProducts.length; i++) {
                        var highestVariantPrice = 0;
                        for (var j = 0; j < tradeInProducts[i].variants.length; j++) {
                            var variantPrice = parseFloat(tradeInProducts[i].variants[j].price);
                            if (highestVariantPrice < variantPrice) {
                                highestVariantPrice = variantPrice;
                            }
                        }
                        html += '<li><label><input type="radio" name="product" value="' + tradeInProducts[i].id + '" /><span>' + tradeInProducts[i].title + '<i class="price">Up to &pound;' + highestVariantPrice.toFixed(2) + '</i></span></label></li>';
                    }

                    $('#TradeInProducts').html(html);

                },
              error:function(){
                    buyAndTradeModalEl.classList.remove('loading');
                    buyAndTradeModalEl.classList.remove('active'); 
                    alert('Sorry - Something went wrong, please retry later');
              }
              });
            };

    $(document).on('change', '#TradeInProducts input[type="radio"]', function() {
        var id = $(this).val();

        for (var i = 0; i < tradeInProducts.length; i++) {
            if (id != tradeInProducts[i].id) continue;
            selectedProduct = tradeInProducts[i];
            break;
        }

        displaySecondStage();
    });

    var displaySecondStage = function() {

        stageElements[0].classList.remove('current-stage');

        stageElements[1].classList.add('current-stage');
        stageElements[1].children[0].innerText = selectedProduct.title + " - Tell us about the device";

        var lcProductTitle = selectedProduct.title.toLowerCase();

        var phoneIdentifiers = ['iphone'];

        for (var i = 0 ; i < phoneIdentifiers.length; i++) {
            if (lcProductTitle.includes(phoneIdentifiers[i])) {
                imeiValid = false;
                stageElements[1].classList.add('imei');
                break;
            }
        }

        var optionsHTML = "";

        for (var i = 0; i < selectedProduct.options.length; i++) {
            optionsHTML += '<h5>' + selectedProduct.options[i].name + '</h5>'
            optionsHTML += '<ul>'
            
            for (var j = 0; j < selectedProduct.options[i].values.length; j++) {
                optionsHTML += '<li><label><input type="radio" class="trade-in-product-option" name="option' + selectedProduct.options[i].position + '" value="' + selectedProduct.options[i].values[j] + '" />';
                optionsHTML += '<span>' + selectedProduct.options[i].values[j] + '</span></label></li>';
            }

            optionsHTML += '</ul>';
        }

        $('#TradeInOptions').html(optionsHTML);
    };

    var displayThirdStage = function() {
        stageElements[1].classList.remove('current-stage');
        stageElements[2].classList.add('current-stage');
    };

    var selectedOptions = {};

    $(document).on('change', 'input.trade-in-product-option', function() {

        document.getElementById('BuyAndTradeCheckout').disabled = true; 

        var name = $(this).prop('name');
        var value = $(this).val();

        if ($(this).prop('checked')) {
            selectedOptions[name] = value;
        }
        
        if (Object.keys(selectedOptions).length != selectedProduct.options.length) {
            return;
        }

        for (var i = 0; i < selectedProduct.variants.length; i++) {
            var variantMatches = true;
            for (var option in selectedOptions) {
                if (selectedProduct.variants[i][option] != selectedOptions[option]) {
                    variantMatches = false;
                    break;
                }
            }
            if (variantMatches) {
                selectedVariant = selectedProduct.variants[i];
                break;
            }
        }

        if (!selectedVariant) return;
        
        if(!stageElements[1].classList.contains('imei')) {
        document.getElementById('BuyAndTradeCheckout').disabled = false;
        }
        
        var format = typeof window.shop != 'undefined' && typeof window.shop.moneyFormat != 'undefined' ? window.shop.moneyFormat : "£{{amount}}";

        document.getElementById('TradeInPriceAmount').innerHTML = Shopify.formatMoney(selectedVariant.price*100, format);

        var priceToPay = 0;

        console.log("PRUCHASE VARIANTS", purchaseVariants);
        
        for (var i = 0; i < purchaseVariants.length; i++) {
            priceToPay += purchaseVariants[i].price;
        }

        priceToPay -= parseInt(selectedVariant.price * 100) ;

        if (priceToPay < 0){
            priceToPay = 0;
        }

        document.getElementById('PayAmount').innerHTML = Shopify.formatMoney(priceToPay, format);

        document.getElementById('BuyAndTradeCheckout');
    });

    $(document).on('keyup', '#IMEINumberInput', function() {
        var value = $(this).val();

        if (value.length > 15) {
            value = value.substring(0,15);
            $(this).val(value);
        }
        
        if (imeiCheck(value)) {
            $(this).removeClass('invalid');
            imeiValid = true;
            imeiNumber = $(this).val();
            if (selectedVariant) {
                document.getElementById('BuyAndTradeCheckout').disabled = false;
            }
        } else {
            imeiNumber = null;
            $(this).addClass('invalid');
            document.getElementById('BuyAndTradeCheckout').disabled = true;
        }
    
    });

    var stepBack = function() {
        stageElements[1].classList.remove('current-stage');
        stageElements[0].classList.add('current-stage');
        selectedProduct = null;
        selectedOptions = {};
        imeiValid = true;
        stageElements[1].classList.remove('imei');
        stageElements[2].classList.remove('current-stage');
        document.getElementById('TradeInPriceAmount').innerHTML = "N/a";
        document.getElementById('PayAmount').innerHTML = "N/a";
        document.getElementById('BuyAndTradeCheckout').disabled = true;
        $('#TradeInProducts input[type="radio"]:checked').prop('checked', false);
    };

    $('.buy-trade-modal__step-back').click(stepBack);

    var closeBuyTradeModalButton = document.getElementById('CloseBuyAndTradeModal');

    if (closeBuyTradeModalButton) {
        closeBuyTradeModalButton.addEventListener('click', function() {
            stepBack();
            buyAndTradeModalEl.classList.remove('active'); 
        });
    }

    var buyAndTradeCheckoutButton = document.getElementById('BuyAndTradeCheckout');

    if (buyAndTradeCheckoutButton) {
        buyAndTradeCheckoutButton.addEventListener('click', function() {
            displayThirdStage();           
        });
    }

    var termsAndCondtionsCheckbox = document.getElementById('BuyAndTradeStage3');

    if (termsAndCondtionsCheckbox) {
        termsAndCondtionsCheckbox.addEventListener('change', function() {

            buyAndTradeModalEl.classList.add('loading');

            var postData = { 
                imei_number: imeiNumber,
                purchase_variants: purchaseVariants.map(function(pv) { return { id: pv.id, quantity: pv.quantity } }), 
                trade_variant_id: selectedVariant.id 
            };

          
          
          $.ajax({
                  url: "https://api.grademobile.co.uk/BuyTrade/MainCreateCheckout",
                  type:"POST",
            	  data: JSON.stringify(postData),
                  headers: { 
                    "Accept" : "application/json; charset=utf-8",
                    "Content-Type": "application/json; charset=utf-8",
                    "APIKey":"4rAhrOcqdWIvNLm2kUhjKeOc3priYS7",
                    "Referer":"grademobile.co.uk"
                  },
                  dataType:"json",
                  async:true,
        success:function(response){
          window.location.href = 'https://api.grademobile.co.uk/BuyTrade/Checkout/' + response.checkout_token;            
          }});          
        });
    }


}